import { getDataSourceList, getDataSourceDetails } from "@/api/datasources";
import DataSource from "@/models/DataSource.model";
import { types } from "./mutations";

export default {
  /**
   * Fetches all the dataSources from the API and saves it in [dataSources]
   * resolves with the STATUS code of the network request
   */
  fetchDataSources: async ({ commit, state, getters }) => {
    // send the cached data if already available in the list
    if (state.dataSources && state.dataSources.length > 0) {
      return getters.getDataSources;
    }

    const { data, status } = await getDataSourceList();
    // check for the response code
    if (status !== 200) {
      return null;
    }
    if (data.data && data.data.length > 0) {
      commit(
        types.SET_DATA_SOURCE_LIST,
        data.data.reduce((result, datasource_details) => {
          const ds = new DataSource(datasource_details);
          result[ds.id] = ds;
          return result;
        }, {})
      );
    } else {
      commit(types.SET_DATA_SOURCE_LIST, {});
    }
  },
  /**
   * Fetches a single datasource details, returns the details if present in the store,
   * else makes a network request to retrieve the data
   */
  fetchDataSourceDetails: async ({ state }, datasource_id) => {
    // check if there are any data available in the list
    if (state.dataSourcesById && state.dataSourcesById.length > 0) {
      // find the datasource details from the list
      return state.dataSources[datasource_id];
    }
    const { data, status } = await getDataSourceDetails(datasource_id);
    return status === 200 ? new DataSource(data.data) : null;
  },

  /**
   * Resets the module state
   */
  reset: async ({ commit }) => {
    commit(types.reset);
  },
};
